import { io } from 'socket.io-client';
import config from '../config/env';

const socket = io(config.api.socketURL, {
  withCredentials: true,
  autoConnect: true,
  transports: ['polling', 'websocket'],
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: 5,
  timeout: 20000,
  upgrade: true,
  rememberUpgrade: true,
  // Suppress all Socket.IO client errors
  rejectUnauthorized: false
});

// Suppress all socket event logging
socket.on('connect', () => {});
socket.on('connect_error', () => {});
socket.on('disconnect', () => {});
socket.on('error', () => {});
socket.io.engine.on('upgrade', () => {});
socket.io.engine.on('error', () => {});

export default socket;